export default {
	areas: [],
	classSteps: [],
	polls: [],
	uid: null,
	currentPollId: null,

	error: null,
}
